import React from 'react';
import { APP_VERSION } from '../constants/version';
import { useTranslation } from '../contexts/LanguageContext';

interface FooterProps {
  companyName: string;
}

const Footer: React.FC<FooterProps> = ({ companyName }) => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gradient-to-r from-[#081a30] via-[#0C2340] to-[#081a30] border-t border-slate-700/50 flex-shrink-0">
      <div className="w-full px-4 sm:px-6 lg:px-8" style={{ padding: '8px' }}>
        <div className="flex justify-between items-center relative">
          <div className="text-slate-400" style={{ fontSize: '12px' }}>
            <a
              href="https://www.ultronsmart.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-slate-300"
            >
              {t.common.poweredBy}
            </a>
            <span className="mx-1">|</span>
            <span className="group cursor-help">
              {t.common.version} {APP_VERSION}
              <span className="hidden group-hover:inline mx-2">
                {t.common.build} {process.env.REACT_APP_BUILD_TIME || new Date().toISOString().replace(/[:.]/g, '').slice(0, -1)}
              </span>
            </span>
          </div>
          <p className="text-sm font-medium text-slate-300 absolute left-1/2 transform -translate-x-1/2">
            {companyName}
          </p>
          <div style={{ width: '200px' }}></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
